export const TrimLeadingZerosStoreNumber = (currentStore:string)=>{
  return currentStore?.replace(/^0+/, '').padStart(3,'0') 
}